import { render } from "./tour-button.vue?vue&type=template&id=65074f3a"
import script from "./tour-button.vue?vue&type=script&lang=js"
export * from "./tour-button.vue?vue&type=script&lang=js"

import "./tour-button.vue?vue&type=style&index=0&id=65074f3a&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__